import {
  PlusOutlined,
  PrinterOutlined,
  SaveOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Divider, Select, Space, Tag, Form as AntForm, DatePicker } from "antd";
import axios from "axios";
import {
  Button,
  DeleteButton,
  Form,
  Modal,
  Table,
  TableCard,
  Input,
  Drawer,
  Export,
} from "components";
import React, { use, useEffect, useRef, useState } from "react";
import {
  FaPen,
  FaPlus,
  FaDownload,
  FaFilter,
  FaCaretRight,
  FaSearchengin,
} from "react-icons/fa6";
import { Link } from "react-router-dom";
import searchFields from "./searchFields";
import dayjs from "dayjs";
import { CgScrollH } from "react-icons/cg";
import { PiVanLight } from "react-icons/pi";
import ExcelRender from "modules/components/ExcelRender";
import { TbFlagSearch } from "react-icons/tb";
import { IoSearchOutline } from "react-icons/io5";

const color = [
  { label: <Tag color="red">Улаан</Tag>, value: "Улаан" },
  { label: <Tag color="blue">Цэнхэр</Tag>, value: "Цэнхэр" },
  { label: <Tag color="green">Ногоон</Tag>, value: "Ногоон" },
];

const status = [
  { label: <Tag color="default">Захиалсан</Tag>, value: 0 },
  { label: <Tag color="processing">Ирж байгаа</Tag>, value: 1 },
  { label: <Tag color="green">Агуулахад буусан</Tag>, value: 2 },
  { label: <Tag color="default">Дууссан</Tag>, value: 3 },
  { label: <Tag color="error">Үйлдвэрийн алдаатай</Tag>, value: 4 },
];
function ProductReport() {
  const [data, setData] = useState([]);
  const [category, setCategory] = useState([]);
  const [brand, setBrand] = useState([]);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [form] = Form.useForm();
  const [dateRange, setDateRange] = useState([]);
  const [optionsName, setOptionsName] = useState("");
  const [header, setHeader] = useState([]);
  const [cols, setCols] = useState([]);
  const [openModalFileEdit, setOpenModalFileEdit] = useState(false);
  const [filterForm] = Form.useForm();
  const inputRef = useRef(null);
  const Today = dayjs();
  const DefaultDateRange = [Today.clone().subtract(0, 'days'), Today];
  const [warehouseid, setWarehouseid] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const brandCounts = data.reduce((acc, curr) => {
    acc[curr.brandname] = (acc[curr.brandname] || 0) + 1;
    return acc;
  }, {});

  useEffect(() => {
    setDateRange(DefaultDateRange)
    getWarehouse();
    // getData();  
    // getCategory();
    // getBrand();
  }, []);

  const getData = () => {
    setLoading(true);
    axios({
      method: "get",
      // url: `/report/customer/${date1}/${date2}`,
    })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };

  const getWarehouse = () => {
    axios({
      method: "get",
      url: "/warehouses"
    })
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          const warehouseData = res.data.map(warehouse => ({
            id: warehouse.id,
            name: warehouse.name
          }));
          setWarehouses(warehouseData);
        } else {
          console.log('No warehouses found or data is not an array');
        }
        
      })
      .catch((err) => {
        console.log('Error fetching warehouses: ', err);
      });
  };
  

  const getCategory = () => {
    axios({
      method: "get",
      url: "/categories",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({ value: item.id, label: item.name, text: item.name })
        );
        setCategory(tmp);
      })
      .catch(() => {});
  };

  const getBrand = () => {
    axios({
      method: "get",
      url: "/brands",
    })
      .then((res) => {
        let tmp = [];
        res.data.map((item) =>
          tmp.push({ value: item.id, label: item.name, text: item.name })
        );
        setBrand(tmp);
      })
      .catch(() => {});
  };
  const handleSearch = () => {
    setLoading(true);
    const [date1, date2] = dateRange.map(date => date.format('YYYY-MM-DD'));

    if(warehouseid){
      axios({
        method: "get",
        url: `/report/product/${date1}/${date2}?warehouseid=${warehouseid}`,
      })
        .then((res) => {
          setData(res.data);
        })
  
        .catch((err) => {})
        .finally(() => setLoading(false));
    }
    else {
      console.log(1);
      axios({
        method: "get",
        url: `/report/product/${date1}/${date2}`,
      })
        .then((res) => {
          setData(res.data);
        })
  
        .catch((err) => {})
        .finally(() => setLoading(false));

    }
  };
  const columns = [
    {
      title: "№",
      dataIndex: "No",
      key: "No",
      fixed:true,
      align: "center",
      cellRender: (e) => <span>{e.rowIndex + currentPage + 1}</span>,
    },
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
      fixed:true,
      // cellRender: ({ value, data }) => (
      //   <div className="flex flex-row">
      //     <div className="action-cell flex items-center gap-2">
      //       <FaCaretRight />
      //     </div>
      //     <Link to={`/products/${data?.id}`}>{value}</Link>
      //   </div>
      // ),
    },
    {
      title: "Үлдэгдэл",
      dataIndex: "balance",
      key: "balance",
      fixed:true,
    },
    {
      title: "Зураг",
      dataIndex: "image",
      key: "image",
      width: 50,
      cellRender: ({ value, data }) => (
        <div className="h-[40px] w-[40px]">
          <img src={`${process.env.REACT_APP_CDN_URL}${value}`} alt="" />
        </div>
      ),
    },
    {
      title: "Барааны код",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Үнэ",
      dataIndex: "price",
      key: "price",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Захиалгийн нийт дүн",
      dataIndex: "ordertotalamount",
      key: "ordertotalamount",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Буцаасан дүн",
      dataIndex: "orderreturnamount",
      key: "orderreturnamount",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Буцаасан захиалга",
      dataIndex: "orderreturnqty",
      key: "orderreturnqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Хүлээгдэж буй захиалга",
      dataIndex: "orderpendingqty",
      key: "orderpendingqty", cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Дууссан захиалга",
      dataIndex: "orderfinishqty",
      key: "orderfinishqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Хүргэлттэй захиалга",
      dataIndex: "orderdeliverqty",
      key: "orderdeliverqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Баталсан захиалга",
      dataIndex: "orderconfirmqty",
      key: "orderconfirmqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Цуцалсан захиалга",
      dataIndex: "ordercancelqty",
      key: "ordercancelqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Татан авалтын нийт дүн",
      dataIndex: "buyingtotalamount",
      key: "buyingtotalamount",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Хүлээгдэж буй татан авалт",
      dataIndex: "buyingpendingqty",
      key: "buyingpendingqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Буусан татан авалт",
      dataIndex: "buyingfinishqty",
      key: "buyingfinishqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Ирж буй татан авалт",
      dataIndex: "buyingdeliverqty",
      key: "buyingdeliverqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Баталгаажсан татан авалт",
      dataIndex: "buyingconfirmqty",
      key: "buyingconfirmqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "Цуцалсан татан авалт",
      dataIndex: "buyingcancelqty",
      key: "buyingcancelqty",
      cellRender: ({value}) => {
        console.log(value)
        if (value !== undefined && value !== null) {
          return value.toLocaleString("en-US");
        }
        return value;
      },
    },
    {
      title: "",
      dataIndex: "balance",
      key: "balance",
    },
    // {
    //   title: "Төлөв",
    //   dataIndex: "status",
    //   key: "status",
    //   cellRender: ({ value, data }) => (
    //     <>{status.find((item) => item?.value === value)?.label}</>
    //   ),
    // },

    // {
    //   title: "",
    //   dataIndex: "action",
    //   key: "action",
    //   width: 90,
    //   cellRender: ({ value, data }) => (
    //     <div className="action-cell flex items-center gap-2">
    //       <Button
    //         type="ghost"
    //         size="sm"
    //         icon={<FaPen />}
    //         onClick={() => handleEditButton(data)}
    //       />
    //       <DeleteButton onClick={() => handleDelete(data)} />
    //     </div>
    //   ),
    // },
  ];

  const fields = [
    {
      label: "Нэр",
      name: "name",
      rules: [{ required: true, message: "Нэр оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    },
    {
      label: "Үйлдвэрлэгч",
      name: "manufacturer",
      rules: [{ required: true, message: "Үйлдвэрлэгч оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    },
    {
      label: "Код",
      name: "code",
      rules: [{ required: true, message: "Код оруулна уу" }],
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label: "Хэмжээ",
      name: "size",
      className: "col-span-6 mb-1",
      inputProps: {},
    },
    {
      label: "Өнгө",
      name: "color",
      className: "col-span-12 mb-1",
      inputProps: {},
    },
    {
      label: "Үнэ",
      name: "price",
      // type: 'number',
      rules: [{ required: true, message: "Үнэ оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    },
    // {
    //   label: 'Төлөв',
    //   name: 'status',
    //   type: 'select',
    //   rules: [{required: true, message: 'Төлөв оруулна уу'}],
    //   className: 'col-span-6 mb-1',
    //   inputProps: {
    //     options: status
    //   }
    // },
    {
      type: "component",
      component: (
        <div className=" col-span-6 ">
          <label className="text-gray-400">Ангилал</label>
          <Form.Item
            name="categoryid"
            className="mt-2"
            rules={[{ required: true, message: "Ангилал оруулна уу" }]}
          >
            <Select
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: "8px 0",
                    }}
                  />
                  <Space>
                    <Input
                      ref={inputRef}
                      style={{ height: "20px" }}
                      value={optionsName}
                      onChange={onNameChange}
                      autoFocus
                    />
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addCategory}
                    ></Button>
                  </Space>
                </>
              )}
              options={category}
            />
          </Form.Item>
        </div>
      ),
    },
    {
      type: "component",
      component: (
        <div className=" col-span-6 ">
          <label className="text-gray-400">Брэнд</label>
          <Form.Item
            name="brandid"
            className="mt-2"
            rules={[{ required: true, message: "Брэнд оруулна уу" }]}
          >
            <Select
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: "8px 0",
                    }}
                  />
                  <Space>
                    <Input
                      style={{ height: "20px" }}
                      ref={inputRef}
                      value={optionsName}
                      onChange={onNameChange}
                      autoFocus
                    />
                    <Button
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={addBrand}
                    ></Button>
                  </Space>
                </>
              )}
              options={brand}
            />
          </Form.Item>
        </div>
      ),
    },
    {
      label: "Тайлбар",
      name: "description",
      type: "textarea",
      className: "col-span-12 mb-1",
      inputProps: {},
    },
    {
      label: "Зураг",
      name: "image",
      type: "image",
      rules: [{ required: true, message: "Зураг оруулна уу" }],
      className: "col-span-12 mb-1",
      inputProps: {},
    },
  ];

  const onNameChange = (event) => {
    setOptionsName(event.target.value);
  };
  const addBrand = () => {
    setOptionsName("");
    axios({
      method: "post",
      url: `/brand`,
      data: { name: optionsName },
    })
      .then((res) => {
        getBrand();
      })
      .catch((err) => {})
      .finally(() => {});
  };
  const addCategory = () => {
    setOptionsName("");
    axios({
      method: "post",
      url: `/category`,
      data: { name: optionsName },
    })
      .then((res) => {
        getCategory();
      })
      .catch((err) => {})
      .finally(() => {});
  };

  const handleSubmit = (values) => {
    console.log("values", values);
    setActionLoading(true);
    const formData = new FormData();
    let keys = Object.keys(values);
    keys.map((item) => {
      if (item !== "image") {
        formData.append(item, values[`${item}`] || "");
      }
    });
    // formData.set('image', values.image[0].originFileObj ? values.image[0].originFileObj : '');
    formData.append(
      "image",
      values.image ? values.image[0]?.originFileObj : ""
    );
    if (editData) {
      formData.append("id", editData.id);
      axios({
        method: "put",
        url: `/product`,
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    } else {
      axios({
        method: "post",
        url: `/product`,
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      })
        .then((res) => {
          getData();
          handleCancel();
        })
        .catch((err) => {})
        .finally(() => {
          setActionLoading(false);
        });
    }
  };

  const handleAddButton = (data) => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditButton = (data) => {
    setEditData(data);
    setShowModal(true);
  };

  const handleDelete = (data) => {
    setActionLoading(true);
    axios({
      method: "delete",
      url: `/product/${data.id}`,
    })
      .then((res) => {
        getData();
        handleCancel();
      })
      .catch((err) => {})
      .finally(() => {
        setActionLoading(false);
      });
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    if (editData) {
      setEditData(null);
    } else {
      form.resetFields();
    }
  };

  const handleFilterSubmit = (values) => {
    setLoading(true);
    axios({
      method: "get",
      url: `/job_ad_  search?name=${values.name}&purpose=${values.purpose}&departmentid=${values.departmentid}&requirements=${values.requirements}&positionid=${values.positionid}&job_time=${values.job_time}&end_date=${values.end_date}`,
    })
      .then((res) => {
        setData(res.data);
        setFilterOpen(false);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  };

  const handleOpenFile = () => {
    setOpenModalFileEdit(true);
  };

  const handleCloseFileModal = () => {
    setOpenModalFileEdit(false);
  };
  const handleOpenModalFileEdit = () => {
    setOpenModalFileEdit(true);
  };

  const handleOpenCloseModalFileEdit = () => {
    setOpenModalFileEdit(false);
  };

  const handleFileSubmit = (values, method) => {
    let tmp = [];
    cols.forEach((item, i) => {
      if (i !== 0) {
        let nameIndex = header.indexOf("name");
        let name = item[nameIndex];
        tmp.push({
          name: name,
        });
      }
    });
    if (method === "post") {
      if (data?.type === 0) {
        setLoading(true);
        axios({
          method: "post",
          url: "/brand",

          data: tmp,
        })
          .then(() => {
            getData();
            handleCloseFileModal();
          })
          .catch((err) => {})
          .then(() => setLoading(false));
      } else {
        setLoading(true);
        axios({
          method: "post",
          url: "/brand",

          data: tmp,
        })
          .then(() => {
            getData();
            handleCloseFileModal();
          })
          .catch((err) => {})
          .then(() => setLoading(false));
      }
    } else {
      if (data?.type === 0) {
        setLoading(true);
        axios({
          method: "put",
          url: "/brand",

          data: tmp,
        })
          .then(() => {
            getData();
            handleOpenCloseModalFileEdit();
          })
          .catch((err) => {})
          .then(() => setLoading(false));
      } else {
        setLoading(true);
        axios({
          method: "put",
          url: "/brand",
          data: tmp,
        })
          .then(() => {
            getData();
            handleOpenCloseModalFileEdit();
          })
          .catch((err) => {})
          .then(() => setLoading(false));
      }
    }
  };
  return (
    <div className="">
      <TableCard
        header={
          <div className="flex flex-col">
            <div className="w-full flex justify-between items-center gap-4">
              <h1 className="text-2xl font-medium">Барааны тайлан</h1>
              <div className="flex items-center gap-2">
              {/* <div className="flex items-center gap-2 mt"> */}
              <select 
                value={warehouseid} 
                onChange={(e) => setWarehouseid(e.target.value)}  
                className="form-select border border-gray-300 rounded-lg  h-9 px-2 py-2"
              >
                <option value="">Бүх агуулах</option>
                {warehouses.map((wh, index) => (
                  <option key={index} value={wh.id}>{wh.name}</option>
                ))}
              </select>

              {/* </div> */}
                  <DatePicker.RangePicker
                    style={{ marginRight: 10 }}
                    value={dateRange}
                    onChange={(dates) => setDateRange(dates)}
                  />
                  <Button type="primary"                  
                   icon={<IoSearchOutline />}
                    onClick={handleSearch} loading={loading}>
                    Хайх
                  </Button>
                <Export fileData={data} fileName={"Барааны тайлан"} />
                {/* <Button
                  icon={<PrinterOutlined className="" />}
                  onClick={handleOpenFile}
                >
                  Excel оруулах
                </Button> */}
                {/* <Button
                  type="primary"
                  icon={<FaPlus />}
                  onClick={handleAddButton}
                >
                  Нэмэх
                </Button> */}
              </div>
            </div>
          </div>
        }
      >
        <Table 
        dataSource={data} 
        columns={columns} 
        loading={loading} 
        columnMinWidth={150}
        scrolling={true}
        tableClass='max-w-[calc(100vw-364px)]'
        />
        <Modal
          title={editData ? "Засах" : "Шинээр нэмэх"}
          open={showModal}
          onCancel={handleCloseModal}
        >
          <Form
            form={form}
            fields={fields}
            editData={editData}
            onFinish={handleSubmit}
            className={"gap-2"}
          >
            <div className="col-span-12 flex justify-end items-center gap-2 mt-5">
              <Button
                type="primary"
                onClick={() => form.submit()}
                loading={actionLoading}
                icon={<SaveOutlined />}
              >
                Хадгалах
              </Button>
              <Button onClick={handleCancel} disabled={actionLoading}>
                Цуцлах
              </Button>
            </div>
          </Form>
        </Modal>
        <Drawer open={filterOpen} onClose={() => setFilterOpen(false)}>
          <div>
            <h1 className="text-xl text-black-text font-bold">Шүүх</h1>
            <Form
              form={filterForm}
              fields={searchFields({
                category: category,
                status: status,
                brand: brand,
                color: color,
              })}
              onFinish={handleFilterSubmit}
              className="gap-4"
            />
            <Button
              className="w-full mt-4"
              size="sm"
              type="primary"
              onClick={() => filterForm.submit()}
            >
              Хайх
            </Button>
          </div>
        </Drawer>
        <Modal
          title={
            <div className="text-lg uppercase">{"Бараа excel оруулах"}</div>
          }
          open={openModalFileEdit}
          onCancel={handleOpenCloseModalFileEdit}
          width={1200}
          destroyOnClose
          footer={false}
        >
          <AntForm
            form={form}
            onFinish={(values) => handleFileSubmit(values, "post")}
          >
            <AntForm.Item>
              <ExcelRender
                header={header}
                setHeader={setHeader}
                cols={cols}
                setCols={setCols}
              />
            </AntForm.Item>
            <AntForm.Item>
              <div className="flex justify-end">
                <Button
                  type="primary"
                  onClick={() => form.submit()}
                  loading={actionLoading}
                  icon={<SaveOutlined />}
                >
                  Хадгалах
                </Button>
              </div>
            </AntForm.Item>
          </AntForm>
        </Modal>
      </TableCard>
      {/* <div className='grid grid-cols-4 gap-4 mt-6'>
        {Object.entries(brandCounts).map(([brand, count]) => (
            <div key={brand} className='border-4	w-[200px] h-[100px] flex justify-between items-center rounded drop-shadow-lg bg-slate-50 '>
                <div className='m-4 text-slate-900	text-2xl	'>
                  {brand}
                </div>  
                <div className='m-4 text-slate-900	text-2xl'>
                  {count}  
                </div>
            </div>
        ))}
      </div> */}
    </div>
  );
}

export default ProductReport;
